import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CompleteBooking } from "../../types/Booking";
import { PadelScore, WinnerTeam } from "../../types/Result";
import { faList, faTrophy } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Input } from "antd";
import { Button, Modal } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";

type Props = {
  booking?: CompleteBooking;
  loading?: boolean;
  onSave: (body: {
    player1Team1Id?: string;
    player2Team1Id?: string;
    player1Team2Id?: string;
    player2Team2Id?: string;
    winnerTeam?: WinnerTeam;
    result?: PadelScore[];
  }) => void;
};

export default function UpdateResult({ booking, onSave, loading }: Props) {
  const [liveScore, setLiveScore] = useState<
    {
      team1?: string;
      team2?: string;
    }[]
  >(
    booking?.match?.score.map((sc) => ({
      team1: sc.team1.toString(),
      team2: sc.team2.toString(),
    })) || []
  );
  const [winner, setWinner] = useState<WinnerTeam | undefined>(
    booking?.match?.winnerTeam
  );

  const handleLiveScoreChange = useCallback(
    (key: keyof PadelScore, index: number) =>
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (+value > 7) {
          return;
        }
        if (value === ",") {
          return;
        }
        if (key === "team1" && value !== "") {
          //controllo team2
          if (+value === 7) {
            //se inserisco 7, se nell'altra squadra il valore che metto non è 5 o 6 non lo faccio mettere
            if (
              liveScore[index] &&
              liveScore[index].team2 &&
              ![5, 6].includes(+liveScore[index].team2!)
            ) {
              return;
            }
          }
          if (+value === 6) {
            //se inserisco 6, il valore deve essere o uguale a 7 o minore/uguale a 4
            if (
              liveScore[index] &&
              liveScore[index].team2 &&
              !(+liveScore[index].team2! <= 4 || +liveScore[index].team2! === 7)
            ) {
              return;
            }
          }
          if (+value === 5) {
            //se inserisco 5 e il valore dell'altro campo non è 7, return
            if (
              liveScore[index] &&
              liveScore[index].team2! &&
              +liveScore[index].team2! !== 7
            ) {
              return;
            }
          }
          if (+value < 5) {
            if (
              liveScore[index] &&
              liveScore[index].team2! &&
              +liveScore[index].team2! > 6
            ) {
              return;
            }
          }
        } else if (key === "team2" && value !== "") {
          //controllo team1
          if (+value === 7) {
            //se inserisco 7, se nell'altra squadra il valore che metto non è 5 o 6 non lo faccio mettere
            if (
              liveScore[index] &&
              liveScore[index].team1! &&
              ![5, 6].includes(+liveScore[index].team1!)
            ) {
              return;
            }
          }
          if (+value === 6) {
            //se inserisco 6, il valore deve essere o uguale a 7 o minore/uguale a 4
            if (
              liveScore[index] &&
              liveScore[index].team1! &&
              !(+liveScore[index].team1! <= 4 || +liveScore[index].team1! === 7)
            ) {
              return;
            }
          }
          if (+value === 5) {
            //se inserisco 5 e il valore dell'altro campo non è 7, return
            if (
              liveScore[index] &&
              liveScore[index].team1! &&
              +liveScore[index].team1! !== 7
            ) {
              return;
            }
          }
          if (+value < 5) {
            if (
              liveScore[index] &&
              liveScore[index].team1! &&
              +liveScore[index].team1! > 6
            ) {
              return;
            }
          }
        }
        setLiveScore((prevScores) => {
          const newScores = [...prevScores];
          newScores[index] = {
            ...prevScores[index],
            [key]: value,
          };
          return newScores;
        });
      },
    [liveScore]
  );

  const disabledSet3 = useMemo(() => {
    return (
      !liveScore ||
      !liveScore[0] ||
      !liveScore[1] ||
      !liveScore[0].team1 ||
      !liveScore[0].team2 ||
      !liveScore[1].team1 ||
      !liveScore[1].team2 ||
      (liveScore[0].team1 &&
        liveScore[0].team2 &&
        liveScore[1].team1 &&
        liveScore[1].team2 &&
        ((+liveScore[0].team1 > +liveScore[0].team2 &&
          +liveScore[1].team1 > +liveScore[1].team2) ||
          (+liveScore[0].team1 < +liveScore[0].team2 &&
            +liveScore[1].team1 < +liveScore[1].team2)))
    );
  }, [liveScore]);

  const disabledSubmitButton = useMemo(() => {
    return (
      !liveScore ||
      !liveScore[0] ||
      !liveScore[1] ||
      !liveScore[0].team1 ||
      !liveScore[0].team2 ||
      !liveScore[1].team1 ||
      !liveScore[1].team2 ||
      (+liveScore[0].team1 > +liveScore[0].team2 &&
        +liveScore[1].team1 < +liveScore[1].team2 &&
        (!liveScore[2] || (!liveScore[2].team1 && !liveScore[2].team2))) ||
      (+liveScore[0].team1 < +liveScore[0].team2 &&
        +liveScore[1].team1 > +liveScore[1].team2 &&
        (!liveScore[2] || (!liveScore[2].team1 && !liveScore[2].team2)))
    );
  }, [liveScore]);

  useEffect(() => {
    if (
      liveScore &&
      liveScore[0] &&
      liveScore[1] &&
      liveScore[0].team1 &&
      liveScore[0].team2 &&
      liveScore[1].team1 &&
      liveScore[1].team2
    ) {
      if (
        +liveScore[0].team1 > +liveScore[0].team2 &&
        +liveScore[1].team1 > +liveScore[1].team2
      ) {
        setWinner(WinnerTeam.Team1);
        setLiveScore((previous) => previous.filter((_, index) => index !== 2));
      } else if (
        +liveScore[0].team1 < +liveScore[0].team2 &&
        +liveScore[1].team1 < +liveScore[1].team2
      ) {
        setWinner(WinnerTeam.Team2);
        setLiveScore((previous) => previous.filter((_, index) => index !== 2));
      } else {
        if (liveScore[2] && liveScore[2].team1 && liveScore[2].team2) {
          if (+liveScore[2].team1 > +liveScore[2].team2) {
            setWinner(WinnerTeam.Team1);
          } else {
            setWinner(WinnerTeam.Team2);
          }
        } else {
          setWinner(undefined);
        }
      }
    } else {
      setWinner(undefined);
    }
  }, [winner, liveScore]);

  const handleResultSubmit = useCallback(() => {
    if (disabledSet3) {
      setLiveScore((previous) => previous.splice(0, 2));
    }
    const payload: {
      player1Team1Id?: string;
      player2Team1Id?: string;
      player1Team2Id?: string;
      player2Team2Id?: string;
      winnerTeam?: WinnerTeam;
      result?: PadelScore[];
    } = {
      winnerTeam: winner,
      result: liveScore.map((sc) => ({
        team1: +(sc.team1 || ""),
        team2: +(sc.team2 || ""),
      })),
    };
    if (booking?.match?.player1Team1) {
      payload.player1Team1Id = booking?.match?.player1Team1.id;
    }
    if (booking?.match?.player2Team1) {
      payload.player2Team1Id = booking?.match?.player2Team1.id;
    }
    if (booking?.match?.player1Team2) {
      payload.player1Team2Id = booking?.match?.player1Team2.id;
    }
    if (booking?.match?.player2Team2) {
      payload.player2Team2Id = booking?.match?.player2Team2.id;
    }
    onSave(payload);
  }, [winner, liveScore, onSave, booking, disabledSet3]);

  return (
    <div>
      <div
        className="py-3"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            paddingTop: 16,
            paddingBottom: 16,
            borderRadius: 12,
            paddingLeft: 8,
            paddingRight: 8,
            border: `2px solid ${
              winner !== undefined && winner === WinnerTeam.Team1
                ? "#4CAF50"
                : "#f25d0b"
            }`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 8,
              alignItems: "center",
            }}
          >
            {booking?.match?.winnerTeam &&
              booking?.match?.winnerTeam === WinnerTeam.Team1 && (
                <FontAwesomeIcon icon={faTrophy} />
              )}
            <span
              style={{
                fontSize: 16,
              }}
            >
              {(booking && booking.match && booking.match.player1Team1
                ? `${booking.match.player1Team1.name.substring(0, 1)}. ${
                    booking?.match.player1Team1.familyName
                  }`
                : "-") +
                (booking && booking.match && booking.match.player2Team1
                  ? ` / ${booking.match.player2Team1.name.substring(0, 1)}. ${
                      booking.match.player2Team1.familyName
                    }`
                  : " / - ")}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 16,
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span>Set 1</span>
            <Input
              inputMode="numeric"
              value={liveScore[0]?.team1 || ""}
              onChange={handleLiveScoreChange("team1", 0)}
              style={{
                width: 50,
                height: 50,
                padding: 12,
                borderRadius: 12,
                border: "2px solid #f25d0b",
                textAlign: "center",
                fontSize: 18,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span>Set 2</span>
            <Input
              inputMode="numeric"
              value={liveScore[1]?.team1 || ""}
              onChange={handleLiveScoreChange("team1", 1)}
              style={{
                width: 50,
                height: 50,
                padding: 12,
                borderRadius: 12,
                border: "2px solid #f25d0b",
                textAlign: "center",
                fontSize: 18,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span>Set 3</span>
            <Input
              disabled={disabledSet3 || false}
              value={liveScore[2]?.team1 || ""}
              onChange={handleLiveScoreChange("team1", 2)}
              inputMode="numeric"
              style={{
                width: 50,
                height: 50,
                padding: 12,
                borderRadius: 12,
                border: `2px solid ${disabledSet3 ? "#d3d3d3" : "#f25d0b"}`,
                textAlign: "center",
                fontSize: 18,
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 16,
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Input
              inputMode="numeric"
              value={liveScore[0]?.team2 || ""}
              onChange={handleLiveScoreChange("team2", 0)}
              style={{
                width: 50,
                height: 50,
                padding: 12,
                borderRadius: 12,
                border: "2px solid #f25d0b",
                textAlign: "center",
                fontSize: 18,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Input
              value={liveScore[1]?.team2 || ""}
              onChange={handleLiveScoreChange("team2", 1)}
              inputMode="numeric"
              style={{
                width: 50,
                height: 50,
                padding: 12,
                borderRadius: 12,
                border: "2px solid #f25d0b",
                textAlign: "center",
                fontSize: 18,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Input
              disabled={disabledSet3 || false}
              value={liveScore[2]?.team2 || ""}
              onChange={handleLiveScoreChange("team2", 2)}
              inputMode="numeric"
              style={{
                width: 50,
                height: 50,
                padding: 12,
                borderRadius: 12,
                border: `2px solid ${disabledSet3 ? "#d3d3d3" : "#f25d0b"}`,
                textAlign: "center",
                fontSize: 18,
              }}
            />
          </div>
        </div>
        <div
          style={{
            paddingTop: 16,
            paddingBottom: 16,
            borderRadius: 12,
            paddingLeft: 8,
            paddingRight: 8,
            border: `2px solid ${
              winner !== undefined && winner === WinnerTeam.Team2
                ? "#4CAF50"
                : "#f25d0b"
            }`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 8,
              alignItems: "center",
            }}
          >
            {booking?.match?.winnerTeam &&
              booking?.match?.winnerTeam === WinnerTeam.Team2 && (
                <FontAwesomeIcon icon={faTrophy} color="#FFF" />
              )}
            <span
              style={{
                fontSize: 16,
                color:
                  booking?.match?.winnerTeam &&
                  booking?.match?.winnerTeam === WinnerTeam.Team2
                    ? "#FFF"
                    : "#000",
              }}
            >
              {(booking && booking.match && booking.match.player1Team2
                ? `${booking.match.player1Team2.name.substring(0, 1)}. ${
                    booking?.match.player1Team2.familyName
                  }`
                : "-") +
                (booking && booking.match && booking.match.player2Team2
                  ? ` / ${booking.match.player2Team2.name.substring(0, 1)}. ${
                      booking.match.player2Team2.familyName
                    }`
                  : " / - ")}
            </span>
          </div>
        </div>
      </div>
      <Modal.Footer>
        <Button
          disabled={disabledSubmitButton || loading}
          onClick={handleResultSubmit}
          variant="success"
          size="sm"
        >
          {loading ? (
            <TailSpin width={20} height={20} />
          ) : (
            <span>
              <FontAwesomeIcon icon={faList} /> Aggiorna risultato
            </span>
          )}
        </Button>
      </Modal.Footer>
    </div>
  );
}
